// frontend/src/features/ups/UpsAccountMenu.js
// UPS shell account controls.
// Keeps logout/account behavior inside the UPS platform shell so the global Header
// can be skipped on /ups-admin/* routes.

import React, { useEffect, useRef, useState } from 'react';
import { User, LogOut } from 'lucide-react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { logout } from '../auth/authSlice';

export default function UpsAccountMenu() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);
  const menuRootRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!menuRootRef.current) return;
      if (!menuRootRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLogout = async () => {
    try {
      await dispatch(logout()).unwrap();
      navigate('/login');
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('Logout failed:', err);
    }
  };

  return (
    <div ref={menuRootRef} className="relative">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="inline-flex items-center gap-2 rounded-xl border border-white/15 bg-white/10 px-4 py-2 text-sm font-semibold text-white transition hover:bg-white/15"
        aria-haspopup="menu"
        aria-expanded={open}
      >
        <User size={17} />
        <span>Account</span>
      </button>

      {open && (
        <div className="absolute right-0 z-50 mt-2 w-48 overflow-hidden rounded-xl border border-app-border bg-app-card shadow-lg">
          <button
            type="button"
            onClick={handleLogout}
            className="flex w-full items-center gap-2 px-4 py-3 text-left text-sm font-semibold text-app-text transition hover:bg-app-surface"
          >
            <LogOut size={16} />
            Logout
          </button>
        </div>
      )}
    </div>
  );
}